<div id="contentCharacteristics">
    <h1>Características</h1>
    <p [innerHTML]="data"></p>
</div>
